import { getDroppedOffFooter, getLatestUpdateLabel } from '../../utils/goLocker';
import TruckIcon from '../../images/icon-truck-24.svg';

import styles from './GoLocker.module.scss';

/** "View Tracking" — truck over its label, like the card's other right-slot actions. */
export const GoLockerViewTracking = ({ onClick }) => (
  <button type="button" className={styles.viewTracking} onClick={onClick}>
    <img src={TruckIcon} alt="" aria-hidden="true" width={24} height={24} />
    <span>View Tracking</span>
  </button>
);

/**
 * GoLockerDroppedOffDetails — the body of the dropped-off GoLocker label card below
 * the bag row (Figma Type3 12373:6840 single / Type4 12373:6993 batch):
 *
 *   ───────────────────────────────────────────
 *   Latest update:                  [View Tracking]   ← batch only; a single has it
 *   Picked up by carrier                                 in the bag row instead
 *   ───────────────────────────────────────────
 *   Dropped off on Oct 29              Park Ave & E 46th St
 */
const GoLockerDroppedOffDetails = ({ status, onViewTracking }) => {
  const { dateLabel, directions } = getDroppedOffFooter(status);

  return (
    <>
      <div className={styles.cardDivider} />
      <div className={styles.latestRow}>
        <div className={styles.latest}>
          <span className={styles.latestLabel}>Latest update:</span>
          <span className={styles.latestValue}>{getLatestUpdateLabel(status)}</span>
        </div>
        {onViewTracking && <GoLockerViewTracking onClick={onViewTracking} />}
      </div>
      {(dateLabel || directions) && (
        <>
          <div className={styles.cardDivider} />
          <div className={styles.droppedFooter}>
            <span className={styles.droppedDate}>{dateLabel}</span>
            <span className={styles.droppedDirections}>{directions}</span>
          </div>
        </>
      )}
    </>
  );
};

export default GoLockerDroppedOffDetails;
